export const INTL_ACTIONS = {
	SET_LANG: 'SET_LANG'
}
